import React from "react";

import { ReactComponent as Logo } from "../assets/icons/logo-banner.svg";

const LogoBanner = () => {
  return <Logo />;
};

export default LogoBanner;
